<template>
  <div class="relative" >
    <div class="" >
      <vs-navbar
        class="vx-navbar navbar-custom navbar-skelton" 
        style="box-shadow: none;"
        :color="navbarColor"
        :class="navbarTextColor"
      >
      </vs-navbar>
    </div>
  </div>
</template>

<script>
import ProfileDropDown from './ProfileDropDown.vue'
export default {
  components: {
    ProfileDropDown,
  },
  data:()=>({
      navbarColor:'#151D2F',
      navbarTextColor:'#fff',
  })
}
</script>

<style>
.position{
  position: static;
  margin-left: 85%;
  padding-top: 5px;
}
.darkModeCard{
  color: #fff;
  background: #151D2F;
}
</style>